<div class="close closeModal" *ngIf="camposObligatorios!='2'">
  <a (click)="close()" title="cerrar"
  ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translate }}</span></a
  >
</div>
<div class="aviso facturacion activaOverflow">
  <div class="tituloSearch">{{ 'CONTACTO' | translate }}</div>
  <div class="avisoInputWrap" [formGroup]="contactoForm">
    <div class="form-group nombre-input-wrapper" *ngIf="divCampos.includes('nombre')">
      <div class="tit-form-group">
        <label for="nombre">{{ 'NOMBRE' | translate }}<span *ngIf="getRequerido('nombre')"> *</span></label>
      </div>
      <input
        [required]="getRequerido('nombre')"
        category="ALFANUMERICO"
        (focus)="focusValue($event)"
        type="text"
        class="form-control"
        id="nombre"
        formControlName="nombre"
        autocomplete="nope"
        #inputName
      />
      <div class="nombre-btn-wrapper">
        <img class="svg nombre-btn" src="assets/img/icon-search.svg" alt="icono search" (click)="abrirBuesqueda(inputName.value)" />
        <ticketing-cross-btn *ngIf="selectedClient" (click)="borrarElCliente()"></ticketing-cross-btn>
      </div>
      <div class="BuscarClienteFacturacion" *ngIf="abrir" style="width:100%">
        <div class="inpuSearch">
          <input type="text" id="search_field" formControlName="nombre" [value]="inputName.value" />
          <div class="close" (click)="abrir = false">
            <a title="borrar"><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translate }}</span></a>
          </div>
        </div>
        <div class="listaPredicc" *ngIf="clientes">
          <div class="Rtable">
            <div class="Rtable-row Rtable-row--head">
              <div class="Rtable-cell cliente-cell column-heading"> {{ 'CLIENTE_NOMBRE' | translate }}</div>
              <div class="Rtable-cell legal-cell column-heading"> {{ 'CLIENTE_DENOMINACION_LEGAL' | translate }}</div>
              <div class="Rtable-cell num-cell column-heading">{{ 'CLIENTE_DNI_CIF' | translate }}</div>
            </div>
            <div
              class="Rtable-row"
              (click)="seleccionarCliente(cliente)"
              *ngFor="let cliente of pagedItems"
            >
              <div class="Rtable-cell cliente-cell">
                <div class="Rtable-cell--content cliente-content">{{ cliente.Nombre }}
                  , {{ cliente.Apellido1 }} {{ cliente.Apellido2 }}
                </div>
              </div>
              <div class="Rtable-cell legal-cell">
                <div class="Rtable-cell--content legal-content"></div>
              </div>
              <div class="Rtable-cell num-cell">
                <div class="Rtable-cell--content num-content">{{ cliente.Cif }}</div>
              </div>
            </div>
          </div>
          <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
            <li>
              <a (click)="setPage(pager.currentPage - 1)" title="Previo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
              </a>
            </li>
            <li *ngFor="let page of pager.pages">
              <a (click)="setPage(page)" [ngClass]="{ active: pager.currentPage === page }">{{
                  page
                }}</a>
            </li>
            <li>
              <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" *ngIf="divCampos.includes('priapellido')">
        <div class="tit-form-group">
          <label for="priapellido">{{ 'PRIMER_APELLIDO' | translate }}<span
            *ngIf="getRequerido('priapellido')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('priapellido')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="priapellido"
          formControlName="priapellido"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('segapellido')">
        <div class="tit-form-group">
          <label for="segapellido">{{ 'SEGUNDO_APELLIDO' | translate }}<span
            *ngIf="getRequerido('segapellido')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('segapellido')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="segapellido"
          formControlName="segapellido"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('email')">
        <div class="tit-form-group">
          <label for="email">Email<span *ngIf="getRequerido('email')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('email')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="email"
          class="form-control"
          id="email"
          formControlName="email"
          autocomplete="nope"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" *ngIf="divCampos.includes('tipodocumento')">
        <div class="tit-form-group">
          <label for="tipodocumento">{{ 'TIPO_DOCUMENTO' | translate }} {{ ' ' }} <span
            *ngIf="getRequerido('tipodocumento')"> *</span></label>
        </div>
        <select name="tipodocumento"
                class="form-control colorfondoblanco"
                id="tipodocumento"
                formControlName="tipodocumento"
                autocomplete="nope">
          <option [value]="item" *ngFor="let item of listaTipoDocumento">{{ item }}</option>
        </select>

        <!--<input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="tipodocumento"
          formControlName="tipodocumento"
          autocomplete="nope"
        />-->
      </div>
      <div class="form-group" *ngIf="divCampos.includes('documento')">
        <div class="tit-form-group">
          <label for="documento">{{ 'DOCUMENTO' | translate }}<span *ngIf="getRequerido('documento')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('documento')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="documento"
          formControlName="documento"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('fechanacimiento')">
        <div class="tit-form-group">
          <label for="fechanacimiento">{{ 'FECHA' | translate }} <span *ngIf="getRequerido('fechanacimiento')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('fechanacimiento')"
          category="ALFANUMERICO"
          placeholder="yyyy-mm-dd"
          type="text"
          class="form-control zindex-1"
          id="fechanacimiento"
          formControlName="fechanacimiento"
          ngbDatepicker #d="ngbDatepicker"
          (click)="d.toggle()"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('sexo')">
        <div class="tit-form-group">
          <label for="sexo">{{ 'SEXO' | translate }}<span *ngIf="getRequerido('sexo')"> *</span></label>
        </div>
        <select name="sexo"
                class="form-control colorfondoblanco"
                id="sexo"
                formControlName="sexo"
                autocomplete="nope">
          <option [value]="item" *ngFor="let item of listaSexo">{{ item }}</option>
        </select>
        <!--<input
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="sexo"
          formControlName="sexo"
          autocomplete="nope"
        />-->
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" *ngIf="divCampos.includes('direccion')">
        <div class="tit-form-group">
          <label for="direccion">{{ 'DIRECCION' | translate }}<span *ngIf="getRequerido('direccion')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('direccion')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="direccion"
          formControlName="direccion"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('localidad')">
        <div class="tit-form-group">
          <label for="ciudad">{{ 'LOCALIDAD' | translate }}<span *ngIf="getRequerido('localidad')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('localidad')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="localidad"
          formControlName="localidad"
          autocomplete="nope"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" *ngIf="divCampos.includes('provincia')">
        <div class="tit-form-group">
          <label for="provincia">{{ 'PROVINCIA' | translate }}<span *ngIf="getRequerido('provincia')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('provincia')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="provincia"
          formControlName="provincia"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('codigopostal')">
        <div class="tit-form-group">
          <label for="codigopostal">{{ 'CODIGO_POSTAL' | translate }}<span
            *ngIf="getRequerido('codigopostal')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('codigopostal')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="codigopostal"
          formControlName="codigopostal"
          autocomplete="nope"
        />
      </div>
      <div class="form-group" *ngIf="divCampos.includes('telefono')">
        <div class="tit-form-group">
          <label for="telefono">{{ 'TELEFONO' | translate }}<span *ngIf="getRequerido('telefono')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('telefono')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="telefono"
          formControlName="telefono"
          autocomplete="nope"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group" *ngIf="divCampos.includes('notas')">
        <div class="tit-form-group">
          <label for="notas">{{ getLabel('notas') }} <span *ngIf="getRequerido('notas')"> *</span></label>
        </div>
        <input
          [required]="getRequerido('notas')"
          category="ALFANUMERICO"
          (focus)="focusValue($event)"
          type="text"
          class="form-control"
          id="notas"
          formControlName="notas"
          maxlength="{{getMaximo('notas')}}"
          autocomplete="nope"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group container-chks-encuesta" *ngIf="divCampos.includes('Pregunta1')">
        <div class="tit-form-group">
          <label for="pregunta1">{{ getLabel('Pregunta1') }} <span *ngIf="getRequerido('Pregunta1')"> *</span></label>
        </div>
        <!-- <select name="pregunta1"  
        class="form-control colorfondoblanco"
        id="pregunta1"
        formControlName="pregunta1"
        autocomplete="nope">
          <option [value]="item" *ngFor="let item of getLista('Pregunta1')">{{item}}</option>
        </select> -->
        <div *ngFor="let item of getLista('Pregunta1')" class="chks-encuesta"
             id="pregunta1"
             (click)="seleccionaCheckEncuesta(item, 'Pregunta1')"
             [class.select]="item.seleccionado"
        >
          <!-- <input type='checkbox' [formControl]='pregunta1'/>--> {{ item.nombre }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group container-chks-encuesta" *ngIf="divCampos.includes('Pregunta2')">
        <div class="tit-form-group">
          <label for="pregunta2">{{ getLabel('Pregunta2') }} <span *ngIf="getRequerido('Pregunta2')"> *</span></label>
        </div>
        <!-- <select name="pregunta2"  
        class="form-control colorfondoblanco"
        id="pregunta2"
        formControlName="pregunta2"
        autocomplete="nope">
          <option [value]="item" *ngFor="let item of getLista('Pregunta2')">{{item}}</option>
        </select> -->
        <div *ngFor="let item of getLista('Pregunta2')" class="chks-encuesta"
             id="pregunta2"
             (click)="seleccionaCheckEncuesta(item, 'Pregunta2')"
             [class.select]="item.seleccionado"
        >
          <!-- <input type='checkbox' [formControl]='pregunta1'/>--> {{ item.nombre }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group container-chks-encuesta" *ngIf="divCampos.includes('Pregunta3')">
        <div class="tit-form-group">
          <label for="pregunta3">{{ getLabel('Pregunta3') }} <span *ngIf="getRequerido('Pregunta3')"> *</span></label>
        </div>
        <!-- <select name="pregunta3"  
        class="form-control colorfondoblanco"
        id="pregunta3"
        formControlName="pregunta3"
        autocomplete="nope">
          <option [value]="item" *ngFor="let item of getLista('Pregunta3')">{{item}}</option>
        </select> -->
        <div *ngFor="let item of getLista('Pregunta3')" class="chks-encuesta"
             id="pregunta2"
             (click)="seleccionaCheckEncuesta(item, 'Pregunta3')"
             [class.select]="item.seleccionado"
        >
          <!-- <input type='checkbox' [formControl]='pregunta1'/>--> {{ item.nombre }}
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group container-chks-encuesta" *ngIf="divCampos.includes('Pregunta4')">
        <div class="tit-form-group">
          <label for="pregunta4">{{ getLabel('Pregunta4') }} <span *ngIf="getRequerido('Pregunta4')"> *</span></label>
        </div>
        <!-- <select name="pregunta4"  
        class="form-control colorfondoblanco"
        id="pregunta4"
        formControlName="pregunta4"
        autocomplete="nope">
          <option [value]="item" *ngFor="let item of getLista('Pregunta4')">{{item}}</option>
        </select> -->
        <div *ngFor="let item of getLista('Pregunta4')" class="chks-encuesta"
             id="pregunta2"
             (click)="seleccionaCheckEncuesta(item, 'Pregunta4')"
             [class.select]="item.seleccionado"
        >
          <!-- <input type='checkbox' [formControl]='pregunta1'/>--> {{ item.nombre }}
        </div>
      </div>
    </div>
    <div
      class="form-row checkboxStyled"
      style="margin-top: 3%"
      [ngClass]="{ checked: contactoForm.controls.politicaprivacidad.value }"
      *ngIf="divCampos.includes('politicaprivacidad')"
    >
      <div class="center">
        <label class="label" for="politicaprivacidad">
          <input
            class="label__checkbox"
            type="checkbox"
            formControlName="politicaprivacidad"
            id="politicaprivacidad"
          />
          <span class="label__check">
            <img class="svg" src="assets/img/checkbox-mark.svg" alt="icono checkbox" />
          </span>
        </label>
      </div>
      <label class="tit-form-group" for="politicaprivacidad" style="padding: 0 45px;"
      >{{ getLabel('politicaprivacidad') }}</label
      >
    </div>
    <div
      class="form-row checkboxStyled"
      style="margin-top: 3%"
      [ngClass]="{ checked: contactoForm.controls.publicidadinterna.value }"
      *ngIf="divCampos.includes('publicidadinterna')"
    >
      <div class="center">
        <label class="label" for="publicidadinterna">
          <input
            class="label__checkbox"
            type="checkbox"
            formControlName="publicidadinterna"
            id="publicidadinterna"
          />
          <span class="label__check">
          <img class="svg" src="assets/img/checkbox-mark.svg" alt="icono checkbox" />
        </span>
        </label>
      </div>
      <label class="tit-form-group" for="publicidadinterna" style="padding: 0 45px;"
      >{{ getLabel('publicidadinterna') }}</label
      >
    </div>
  </div>
  <div class="faturacion-fila">
    <div class="ticket-info" *ngIf="camposObligatorios!='2'">
      <div class="inputControl botones">
        <button type="button" value="cancelar" class="cancelar" (click)="close()">{{ 'CANCELAR' | translate }}</button>
      </div>
    </div>
    <div class="ticket-info">
      <div class="inputControl botones">
        <button
          type="button"
          value="ACEPTAR"
          class="pagar aceptar"
          (click)="guardar()"
          [disabled]="contactoForm.invalid"
        >
          {{ 'ACEPTAR' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="keyboardWrap" *ngIf="keyboardWrapOn">
  <ticketing-keyboard></ticketing-keyboard>
  <ticketing-numpad></ticketing-numpad>
</div>

